<template>
    <eSesjaModal size="large" class="client-invoice-modal">
        <eSesjaModalHeader @close="closeModal">
            {{ $t('com.file.client-invoice-data-settings.edit-title') }}
        </eSesjaModalHeader>
        <eSesjaModalBody>
            <p class="py-2">{{ $t('com.file.client-invoice-data-settings.invoice-description') }}</p>
            <label class="esesja-modal__wraper__body__label">
                {{
            $t('com.file.client-invoice-data-settings.invoice-email')
                }}
            </label>
            <section class="esesja-modal__row">
                <input class="esesja-modal__wraper__body__input"
                       :class="{ 'input-has-error': isTooLong(model.invoiceEmail, maxLengths.invoiceEmail) || isInvoiceEmailInvalid(model.invoiceEmail) }" type="email"
                       :maxlength="maxLengths.invoiceEmail" v-model="model.invoiceEmail" />
            </section>
            <ErrorMessage v-if="isInvoiceEmailInvalid(model.invoiceEmail)" :errorMsgs="[$t('com.validation-error.invalid-email-format')]" />
            <CharactersCounter :text="model.invoiceEmail" :maxLenght="maxLengths.invoiceEmail" />

            <!-- Buyer section - single column -->
            <section class="buyer-section py-3">
                <h5 class="client-invoice-data__group__title">{{ $t('com.file.client-invoice-data-settings.buyer') }}</h5>
                <label class="esesja-modal__wraper__body__label">{{ $t('com.file.client-invoice-data-settings.buyer-group') }}</label>
                <section class="esesja-modal__row pb-3">
                    <Multiselect v-model="selectedBuyerGroup" :options="buyerGroupOptions" :searchable="true"
                                 :close-on-select="true" :create-option="false" :object="true" :can-clear="false"
                                 :noResultsText="$t('com.global.no-results')" :noOptionsText="$t('com.global.no-options')" />
                </section>
                <section class="d-flex flex-row gap-1 flex-fill">
                    <section class="d-flex flex-column w-50">
                        <label class="esesja-modal__wraper__body__label">{{ $t('com.file.client-invoice-data-settings.country-id') }}</label>
                        <section class="esesja-modal__row">
                            <Multiselect v-model="selectedCountry" :options="countriesOptions" :searchable="true"
                                         :close-on-select="true" :create-option="false" :object="true" :can-clear="false"
                                         :noResultsText="$t('com.global.no-results')" :noOptionsText="$t('com.global.no-options')" />
                        </section>
                    </section>
                    <section class="d-flex flex-column w-50">
                        <label class="esesja-modal__wraper__body__label">{{ $t('com.file.client-invoice-data-settings.tax-id') }}</label>
                        <section class="esesja-modal__row">
                            <section class="d-flex flex-row">
                                <input class="esesja-modal__wraper__body__input"
                                       :class="{ 'input-has-error': isTooLong(model.buyer.taxId, maxLengths.buyerTaxId) || isRequiredMissing(model.buyer.taxId) || (isValidNipDigitsOnly(model.buyer.taxId) === false && selectedCountry != null && selectedCountry.symbol === 'PL') }"
                                       type="text" inputmode="numeric" :maxlength="maxLengths.buyerTaxId"
                                       v-model="model.buyer.taxId" />
                                <section class="button-show" @click="fetchGusData(model.buyer.taxId, 'buyer')"
                                         v-if="selectedCountry != null && selectedCountry.symbol === 'PL'"
                                         v-tooltip="$t('com.file.client-invoice-data-settings.fetch-gus-data')">
                                    <img src="~@/assets/icons/panel/Contacts/search.svg" />
                                </section>
                            </section>
                            <CharactersCounter :text="model.buyer.taxId" :maxLenght="maxLengths.buyerTaxId" />
                        </section>
                    </section>
                </section>
                <label class="esesja-modal__wraper__body__label">{{ $t('com.file.client-invoice-data-settings.name') }}</label>
                <section class="esesja-modal__row">
                    <input class="esesja-modal__wraper__body__input"
                           :class="{ 'input-has-error': isTooLong(model.buyer.name, maxLengths.buyerName) || isRequiredMissing(model.buyer.name) }"
                           :maxlength="maxLengths.buyerName" v-model="model.buyer.name" />
                    <CharactersCounter :text="model.buyer.name" :maxLenght="maxLengths.buyerName" />
                </section>
                <section class="d-flex flex-row gap-1 flex-fill">
                    <section class="d-flex flex-column w-50">
                        <label class="esesja-modal__wraper__body__label">{{ $t('com.file.client-invoice-data-settings.city') }}</label>
                        <section class="esesja-modal__row">
                            <input class="esesja-modal__wraper__body__input"
                                   :class="{ 'input-has-error': isTooLong(model.buyer.city, maxLengths.buyerCity) }"
                                   :maxlength="maxLengths.buyerCity" v-model="model.buyer.city" />
                            <CharactersCounter :text="model.buyer.city" :maxLenght="maxLengths.buyerCity" />
                        </section>
                    </section>
                    <section class="d-flex flex-column flex-fill">
                        <label class="esesja-modal__wraper__body__label">{{ $t('com.file.client-invoice-data-settings.address') }}</label>
                        <section class="esesja-modal__row">
                            <input class="esesja-modal__wraper__body__input"
                                   :class="{ 'input-has-error': isTooLong(model.buyer.address, maxLengths.buyerAddress) }"
                                   :maxlength="maxLengths.buyerAddress" v-model="model.buyer.address" />
                            <CharactersCounter :text="model.buyer.address" :maxLenght="maxLengths.buyerAddress" />
                        </section>
                    </section>
                </section>
                <section class="d-flex flex-row gap-1 flex-fill">
                    <section class="d-flex flex-column w-50">
                        <label class="esesja-modal__wraper__body__label">{{ $t('com.file.client-invoice-data-settings.postal-code') }}</label>
                        <section class="esesja-modal__row">
                            <input class="esesja-modal__wraper__body__input"
                                   :class="{ 'input-has-error': isTooLong(model.buyer.postalCode, maxLengths.buyerPostalCode) }"
                                   :maxlength="maxLengths.buyerPostalCode" v-model="model.buyer.postalCode" />
                            <CharactersCounter :text="model.buyer.postalCode" :maxLenght="maxLengths.buyerPostalCode" />
                        </section>
                    </section>
                    <section class="d-flex flex-column w-50">
                        <label class="esesja-modal__wraper__body__label">{{ $t('com.file.client-invoice-data-settings.post-office') }}</label>
                        <section class="esesja-modal__row">
                            <input class="esesja-modal__wraper__body__input"
                                   :class="{ 'input-has-error': isTooLong(model.buyer.postOffice, maxLengths.buyerPostOffice) }"
                                   :maxlength="maxLengths.buyerPostOffice" v-model="model.buyer.postOffice" />
                            <CharactersCounter :text="model.buyer.postOffice" :maxLenght="maxLengths.buyerPostOffice" />
                        </section>
                    </section>
                </section>
                <label class="esesja-modal__wraper__body__label">{{ $t('com.file.client-invoice-data-settings.gln') }}</label>
                <section class="esesja-modal__row">
                    <input class="esesja-modal__wraper__body__input"
                           :class="{ 'input-has-error': isTooLong(model.buyer.gln, maxLengths.buyerGln) }"
                           :maxlength="maxLengths.buyerGln" v-model="model.buyer.gln" />
                    <CharactersCounter :text="model.buyer.gln" :maxLenght="maxLengths.buyerGln" />
                </section>
            </section>

            <!-- Want recipient checkbox - shows when no BuyerGroup forcing recipient -->
            <section v-if="!isRecipientRequired" class="edit-point-form__checkbox-top py-2">
                <section class="edit-point-form__checkbox-wrapper">
                    <input type="checkbox" class="edit-point-form__checkbox" v-model="wantsRecipient" />
                    <section class="edit-point-form__checkbox-mark">
                        <img src="~@/assets/icons/components/accept-mark.svg" />
                    </section>
                </section>
                <label class="edit-point-form__label edit-point-form__label--checkbox" @click="wantsRecipient = !wantsRecipient">
                    {{ $t('com.file.client-invoice-data-settings.want-recipient') }}
                </label>
            </section>

            <!-- Recipient section - shown when wantsRecipient OR BuyerGroup (JST/GV) selected -->
            <section v-if="showRecipientSection" class="recipient-section py-3 mt-3">
                <h5 class="client-invoice-data__group__title">{{ $t('com.file.client-invoice-data-settings.recipient') }}</h5>

                <!-- Main recipient - collapsible -->
                <section class="recipient-card">
                    <header class="recipient-card__header" @click="mainRecipientExpanded = !mainRecipientExpanded">
                        <span class="recipient-card__title">
                            {{ mainRecipientHeaderTitle }}
                            <span class="recipient-card__chevron" :class="{ 'recipient-card__chevron--expanded': mainRecipientExpanded }">▼</span>
                        </span>
                    </header>
                    <section v-show="mainRecipientExpanded" class="recipient-card__body">
                        <label class="esesja-modal__wraper__body__label">{{ $t('com.file.client-invoice-data-settings.recipient-role') }}</label>
                        <section class="esesja-modal__row pb-3">
                            <Multiselect v-model="selectedRecipientRole" :options="recipientRoleOptions" :searchable="true"
                                         :close-on-select="true" :create-option="false" :object="true"
                                         :disabled="isRecipientRoleLocked" :can-clear="false"
                                         :noResultsText="$t('com.global.no-results')" :noOptionsText="$t('com.global.no-options')" />
                        </section>
                        <section class="d-flex flex-row gap-1 flex-fill">
                            <section class="d-flex flex-column w-50">
                                <label class="esesja-modal__wraper__body__label">{{ $t('com.file.client-invoice-data-settings.country-id') }}</label>
                                <section class="esesja-modal__row">
                                    <Multiselect v-model="selectedRecipientCountry" :options="countriesOptions"
                                                 :searchable="true" :close-on-select="true" :create-option="false" :object="true"
                                                 :can-clear="false" :noResultsText="$t('com.global.no-results')"
                                                 :noOptionsText="$t('com.global.no-options')" />
                                </section>
                            </section>
                            <section class="d-flex flex-column w-50">
                                <label class="esesja-modal__wraper__body__label">{{ $t('com.file.client-invoice-data-settings.tax-id') }}</label>
                                <section class="esesja-modal__row">
                                    <section class="d-flex flex-row">
                                        <input class="esesja-modal__wraper__body__input"
                                               :class="{ 'input-has-error': isTooLong(model.recipient.taxId, maxLengths.recipientTaxId) || (model.recipient.taxId && isValidNipDigitsOnly(model.recipient.taxId) === false && selectedRecipientCountry != null && selectedRecipientCountry.symbol === 'PL') }"
                                               type="text" inputmode="numeric" :maxlength="maxLengths.recipientTaxId"
                                               v-model="model.recipient.taxId" />
                                        <section class="button-show"
                                                 @click="fetchGusData(model.recipient.taxId, 'recipient')"
                                                 v-if="selectedRecipientCountry != null && selectedRecipientCountry.symbol === 'PL'"
                                                 v-tooltip="$t('com.file.client-invoice-data-settings.fetch-gus-data')">
                                            <img src="~@/assets/icons/panel/Contacts/search.svg" />
                                        </section>
                                    </section>
                                    <CharactersCounter :text="model.recipient.taxId" :maxLenght="maxLengths.recipientTaxId" />
                                </section>
                            </section>
                        </section>
                        <label class="esesja-modal__wraper__body__label">{{ $t('com.file.client-invoice-data-settings.recipient-internal-identifier') }} {{ $t('com.file.client-invoice-data-settings.recipient-internal-identifier-format') }}</label>
                        <section class="esesja-modal__row">
                            <input class="esesja-modal__wraper__body__input"
                                   :class="{ 'input-has-error': isTooLong(model.recipientInternalIdentifier, maxLengths.recipientInternalIdentifier) || (model.recipientInternalIdentifier && !isValidRecipientInternalIdentifier(model.recipientInternalIdentifier)) }"
                                   :maxlength="maxLengths.recipientInternalIdentifier"
                                   v-model="model.recipientInternalIdentifier" />
                            <ErrorMessage v-if="model.recipientInternalIdentifier && !isValidRecipientInternalIdentifier(model.recipientInternalIdentifier)" :errorMsgs="[$t('com.validation-error.invalid-recipient-internal-identifier-format')]" />
                            <section class="d-flex flex-row align-items-center justify-content-between flex-fill recipient-internal-id-info">
                                <span class="recipient-internal-id-info__text">{{ $t('com.file.client-invoice-data-settings.recipient-internal-identifier-information') }}</span>
                                <CharactersCounter :text="model.recipientInternalIdentifier" :maxLenght="maxLengths.recipientInternalIdentifier" />
                            </section>
                        </section>
                        <label class="esesja-modal__wraper__body__label">{{ $t('com.file.client-invoice-data-settings.name') }}</label>
                        <section class="esesja-modal__row">
                            <input class="esesja-modal__wraper__body__input"
                                   :class="{ 'input-has-error': isTooLong(model.recipient.name, maxLengths.recipientName) || (isRecipientRequired && isRequiredMissing(model.recipient.name)) }"
                                   :maxlength="maxLengths.recipientName" v-model="model.recipient.name" />
                            <CharactersCounter :text="model.recipient.name" :maxLenght="maxLengths.recipientName" />
                        </section>
                        <section class="d-flex flex-row gap-1 flex-fill">
                            <section class="d-flex flex-column w-50">
                                <label class="esesja-modal__wraper__body__label">{{ $t('com.file.client-invoice-data-settings.city') }}</label>
                                <section class="esesja-modal__row">
                                    <input class="esesja-modal__wraper__body__input"
                                           :class="{ 'input-has-error': isTooLong(model.recipient.city, maxLengths.recipientCity) }"
                                           :maxlength="maxLengths.recipientCity" v-model="model.recipient.city" />
                                    <CharactersCounter :text="model.recipient.city" :maxLenght="maxLengths.recipientCity" />
                                </section>
                            </section>
                            <section class="d-flex flex-column w-50">
                                <label class="esesja-modal__wraper__body__label">{{ $t('com.file.client-invoice-data-settings.address') }}</label>
                                <section class="esesja-modal__row">
                                    <input class="esesja-modal__wraper__body__input"
                                           :class="{ 'input-has-error': isTooLong(model.recipient.address, maxLengths.recipientAddress) }"
                                           :maxlength="maxLengths.recipientAddress" v-model="model.recipient.address" />
                                    <CharactersCounter :text="model.recipient.address" :maxLenght="maxLengths.recipientAddress" />
                                </section>
                            </section>
                        </section>
                        <section class="d-flex flex-row gap-1 flex-fill">
                            <section class="d-flex flex-column w-50">
                                <label class="esesja-modal__wraper__body__label">{{ $t('com.file.client-invoice-data-settings.postal-code') }}</label>
                                <section class="esesja-modal__row">
                                    <input class="esesja-modal__wraper__body__input"
                                           :class="{ 'input-has-error': isTooLong(model.recipient.postalCode, maxLengths.recipientPostalCode) }"
                                           :maxlength="maxLengths.recipientPostalCode" v-model="model.recipient.postalCode" />
                                    <CharactersCounter :text="model.recipient.postalCode" :maxLenght="maxLengths.recipientPostalCode" />
                                </section>
                            </section>
                            <section class="d-flex flex-column w-50">
                                <label class="esesja-modal__wraper__body__label">{{ $t('com.file.client-invoice-data-settings.post-office') }}</label>
                                <section class="esesja-modal__row">
                                    <input class="esesja-modal__wraper__body__input"
                                           :class="{ 'input-has-error': isTooLong(model.recipient.postOffice, maxLengths.recipientPostOffice) }"
                                           :maxlength="maxLengths.recipientPostOffice" v-model="model.recipient.postOffice" />
                                    <CharactersCounter :text="model.recipient.postOffice" :maxLenght="maxLengths.recipientPostOffice" />
                                </section>
                            </section>
                        </section>
                        <label class="esesja-modal__wraper__body__label">{{ $t('com.file.client-invoice-data-settings.gln') }}</label>
                        <section class="esesja-modal__row">
                            <input class="esesja-modal__wraper__body__input"
                                   :class="{ 'input-has-error': isTooLong(model.recipient.gln, maxLengths.recipientGln) }"
                                   :maxlength="maxLengths.recipientGln" v-model="model.recipient.gln" />
                            <CharactersCounter :text="model.recipient.gln" :maxLenght="maxLengths.recipientGln" />
                        </section>
                    </section>
                </section>

                <!-- Additional recipients - collapsible cards -->
                <section v-for="(recipient, idx) in model.additionalRecipiants" :key="'add-' + idx" class="recipient-card mt-3">
                    <header class="recipient-card__header" @click="toggleAdditionalRecipient(idx)">
                        <span class="recipient-card__title">
                            {{ getAdditionalRecipientTitle(idx, recipient) }}
                            <span class="recipient-card__chevron" :class="{ 'recipient-card__chevron--expanded': isAdditionalRecipientExpanded(idx) }">▼</span>
                        </span>
                        <button type="button" class="recipient-card__remove" @click.stop="removeAdditionalRecipient(idx)"
                                v-tooltip="$t('com.file.client-invoice-data-settings.remove-recipient')">
                            ✕
                        </button>
                    </header>
                    <section v-show="isAdditionalRecipientExpanded(idx)" class="recipient-card__body">
                        <label class="esesja-modal__wraper__body__label">{{ $t('com.file.client-invoice-data-settings.recipient-role') }}</label>
                        <section class="esesja-modal__row pb-3">
                            <Multiselect v-model="selectedAdditionalRecipientRoles[idx]" :options="recipientRoleOptions" :searchable="true"
                                         :close-on-select="true" :create-option="false" :object="true" :can-clear="false"
                                         :noResultsText="$t('com.global.no-results')" :noOptionsText="$t('com.global.no-options')" />
                        </section>
                        <section class="d-flex flex-row gap-1 flex-fill">
                            <section class="d-flex flex-column w-50">
                                <label class="esesja-modal__wraper__body__label">{{ $t('com.file.client-invoice-data-settings.country-id') }}</label>
                                <section class="esesja-modal__row">
                                    <Multiselect v-model="selectedAdditionalRecipientCountries[idx]" :options="countriesOptions"
                                                 :searchable="true" :close-on-select="true" :create-option="false" :object="true"
                                                 :can-clear="false" :noResultsText="$t('com.global.no-results')"
                                                 :noOptionsText="$t('com.global.no-options')" />
                                </section>
                            </section>
                            <section class="d-flex flex-column w-50">
                                <label class="esesja-modal__wraper__body__label">{{ $t('com.file.client-invoice-data-settings.tax-id') }}</label>
                                <section class="esesja-modal__row">
                                    <section class="d-flex flex-row">
                                        <input class="esesja-modal__wraper__body__input"
                                               :class="{ 'input-has-error': recipient.taxId && isValidNipDigitsOnly(recipient.taxId) === false && selectedAdditionalRecipientCountries[idx] != null && selectedAdditionalRecipientCountries[idx].symbol === 'PL' }"
                                               type="text" inputmode="numeric" :maxlength="maxLengths.recipientTaxId"
                                               v-model="recipient.taxId" />
                                        <section class="button-show"
                                                 @click="fetchGusData(recipient.taxId, 'additionalRecipient', idx)"
                                                 v-if="selectedAdditionalRecipientCountries[idx] != null && selectedAdditionalRecipientCountries[idx].symbol === 'PL'"
                                                 v-tooltip="$t('com.file.client-invoice-data-settings.fetch-gus-data')">
                                            <img src="~@/assets/icons/panel/Contacts/search.svg" />
                                        </section>
                                    </section>
                                    <CharactersCounter :text="recipient.taxId" :maxLenght="maxLengths.recipientTaxId" />
                                </section>
                            </section>
                        </section>
                        <label class="esesja-modal__wraper__body__label">{{ $t('com.file.client-invoice-data-settings.recipient-internal-identifier') }} {{ $t('com.file.client-invoice-data-settings.recipient-internal-identifier-format') }}</label>
                        <section class="esesja-modal__row">
                            <input class="esesja-modal__wraper__body__input"
                                   :class="{ 'input-has-error': isTooLong(recipient.recipientInternalIdentifier, maxLengths.recipientInternalIdentifier) || (recipient.recipientInternalIdentifier && !isValidRecipientInternalIdentifier(recipient.recipientInternalIdentifier)) }"
                                   :maxlength="maxLengths.recipientInternalIdentifier"
                                   v-model="recipient.recipientInternalIdentifier" />
                            <ErrorMessage v-if="recipient.recipientInternalIdentifier && !isValidRecipientInternalIdentifier(recipient.recipientInternalIdentifier)" :errorMsgs="[$t('com.validation-error.invalid-recipient-internal-identifier-format')]" />
                            <section class="d-flex flex-row align-items-center justify-content-between flex-fill recipient-internal-id-info">
                                <span class="recipient-internal-id-info__text">{{ $t('com.file.client-invoice-data-settings.recipient-internal-identifier-information') }}</span>
                                <CharactersCounter :text="recipient.recipientInternalIdentifier" :maxLenght="maxLengths.recipientInternalIdentifier" />
                            </section>
                        </section>
                        <label class="esesja-modal__wraper__body__label">{{ $t('com.file.client-invoice-data-settings.name') }}</label>
                        <section class="esesja-modal__row">
                            <input class="esesja-modal__wraper__body__input"
                                   :class="{ 'input-has-error': ((recipient.taxId || recipient.recipientInternalIdentifier) && isRequiredMissing(recipient.name)) }"
                                   :maxlength="maxLengths.recipientName" v-model="recipient.name" />
                            <CharactersCounter :text="recipient.name" :maxLenght="maxLengths.recipientName" />
                        </section>
                        <section class="d-flex flex-row gap-1 flex-fill">
                            <section class="d-flex flex-column w-50">
                                <label class="esesja-modal__wraper__body__label">{{ $t('com.file.client-invoice-data-settings.city') }}</label>
                                <section class="esesja-modal__row">
                                    <input class="esesja-modal__wraper__body__input"
                                           :maxlength="maxLengths.recipientCity" v-model="recipient.city" />
                                    <CharactersCounter :text="recipient.city" :maxLenght="maxLengths.recipientCity" />
                                </section>
                            </section>
                            <section class="d-flex flex-column w-50">
                                <label class="esesja-modal__wraper__body__label">{{ $t('com.file.client-invoice-data-settings.address') }}</label>
                                <section class="esesja-modal__row">
                                    <input class="esesja-modal__wraper__body__input"
                                           :maxlength="maxLengths.recipientAddress" v-model="recipient.address" />
                                    <CharactersCounter :text="recipient.address" :maxLenght="maxLengths.recipientAddress" />
                                </section>
                            </section>
                        </section>
                        <section class="d-flex flex-row gap-1 flex-fill">
                            <section class="d-flex flex-column w-50">
                                <label class="esesja-modal__wraper__body__label">{{ $t('com.file.client-invoice-data-settings.postal-code') }}</label>
                                <section class="esesja-modal__row">
                                    <input class="esesja-modal__wraper__body__input"
                                           :maxlength="maxLengths.recipientPostalCode" v-model="recipient.postalCode" />
                                    <CharactersCounter :text="recipient.postalCode" :maxLenght="maxLengths.recipientPostalCode" />
                                </section>
                            </section>
                            <section class="d-flex flex-column w-50">
                                <label class="esesja-modal__wraper__body__label">{{ $t('com.file.client-invoice-data-settings.post-office') }}</label>
                                <section class="esesja-modal__row">
                                    <input class="esesja-modal__wraper__body__input"
                                           :maxlength="maxLengths.recipientPostOffice" v-model="recipient.postOffice" />
                                    <CharactersCounter :text="recipient.postOffice" :maxLenght="maxLengths.recipientPostOffice" />
                                </section>
                            </section>
                        </section>
                        <label class="esesja-modal__wraper__body__label">{{ $t('com.file.client-invoice-data-settings.gln') }}</label>
                        <section class="esesja-modal__row">
                            <input class="esesja-modal__wraper__body__input"
                                   :maxlength="maxLengths.recipientGln" v-model="recipient.gln" />
                            <CharactersCounter :text="recipient.gln" :maxLenght="maxLengths.recipientGln" />
                        </section>
                    </section>
                </section>

                <button type="button" class="client-invoice-data__group__button mt-3" @click="addAdditionalRecipient">
                    + {{ $t('com.file.client-invoice-data-settings.add-recipient') }}
                </button>
            </section>
            <section class="edit-point-form__checkbox-top">
                <section class="edit-point-form__checkbox-wrapper">
                    <input type="checkbox" class="edit-point-form__checkbox" v-model="userConfirmTaxData" />
                    <section class="edit-point-form__checkbox-mark">
                        <img src="~@/assets/icons/components/accept-mark.svg" />
                    </section>
                </section>
                <label class="
                                edit-point-form__label
                                edit-point-form__label--checkbox
                            " @click="userConfirmTaxData = !userConfirmTaxData">
                    {{$t('com.file.client-invoice-data-settings.confirm-tax-data')}}
                </label>
            </section>
        </eSesjaModalBody>
        <eSesjaModalFooter>
            <eSesjaModalButtonCancel @close="closeModal">
                {{ $t('com.global.cancel') }}
            </eSesjaModalButtonCancel>
            <eSesjaModalButtonSave @click="saveData" :disabled="isSaving || hasError || !userConfirmTaxData">
                {{ $t('com.global.save') }}
            </eSesjaModalButtonSave>
        </eSesjaModalFooter>
    </eSesjaModal>
</template>
<script charset="utf-8">
    import ClientInvoiceDataService from "@/services/client.invoice.data.service";
    import CountryService from "@/services/country.service";
    import UserService from "@/services/user.service";
    import Multiselect from "@vueform/multiselect";
    import CharactersCounter from "@/components/BasicControls/CharactersCounter.vue";
    import ErrorMessage from "@/components/BasicControls/ErrorMessage.vue";
    import { isValidNipDigitsOnly, validateEmail } from "@/helpers/utils";

    const createEmptyContractor = () => ({
        name: "",
        address: "",
        postalCode: "",
        city: "",
        postOffice: "",
        taxId: "",
        gln: "",
        country: {
            id: 0,
            country: "",
            symbol: ""
        }
    });

    const createEmptyRecipient = () => ({
        ...createEmptyContractor(),
        recipientRole: null,
        recipientInternalIdentifier: ""
    });

    const createEmptyData = () => ({
        id: 0,
        buyer: createEmptyContractor(),
        recipient: createEmptyContractor(),
        additionalRecipiants: [],
        buyerGroup: null,
        recipientRole: null,
        invoiceEmail: "",
        recipientInternalIdentifier: "",
        lastVerificationDate: null
    });

    export default {
        name: "ClientInvoiceBuyerModal",
        components: {
            Multiselect,
            CharactersCounter,
            ErrorMessage
        },
        data() {
            return {
                model: createEmptyData(),
                isSaving: false,
                selectedCountry: null,
                selectedRecipientCountry: null,
                selectedBuyerGroup: null,
                selectedRecipientRole: null,
                wantsRecipient: false,
                mainRecipientExpanded: true,
                expandedAdditionalRecipients: {},
                selectedAdditionalRecipientCountries: [],
                selectedAdditionalRecipientRoles: [],
                buyerGroups: [],
                recipientRoles: [],
                userConfirmTaxData: false,
                maxLengths: {
                    invoiceEmail: 100,
                    buyerName: 200,
                    buyerAddress: 200,
                    buyerPostalCode: 50,
                    buyerCity: 100,
                    buyerPostOffice: 100,
                    buyerTaxId: 50,
                    buyerGln: 20,
                    recipientName: 200,
                    recipientAddress: 200,
                    recipientPostalCode: 50,
                    recipientCity: 100,
                    recipientPostOffice: 100,
                    recipientTaxId: 50,
                    recipientGln: 20,
                    recipientInternalIdentifier: 16
                },
            };
        },
        async mounted() {
            try {
                this.$store.commit("showLoader");
                await this.loadCountries(),
                    await this.loadBuyerGroups(),
                    await this.loadRecipientRoles(),
                    await this.fetchInvoiceData()
                await this.$nextTick();
            }
            finally {
                this.$store.commit("hideLoader");
            }
        },
        watch: {
            buyerGroupCode() {
                this.applyRecipientRoleFromBuyerGroup();
                if (this.isRecipientRequired) {
                    this.wantsRecipient = true;
                }
            },
            recipientRoleOptions() {
                this.applyRecipientRoleFromBuyerGroup();
            }
        },
        computed: {
            countriesOptions() {
                const countries = this.$store.state.countryStore.countries || [];
                return countries.map(item => ({
                    label: item.country ? `${item.country}${item.symbol ? ` (${item.symbol})` : ""}` : (item.symbol || ""),
                    value: item.id,
                    country: item.country,
                    symbol: item.symbol
                }));
            },
            defaultCountry() {
                return this.countriesOptions.find(c => (c.symbol || "").toUpperCase() === "PL") || this.countriesOptions[0] || null;
            },
            buyerGroupOptions() {
                return (this.buyerGroups || []).map(item => ({
                    value: item.id ?? item.Id,
                    label: item.label ?? item.Label ?? item.code ?? item.Code ?? "",
                    code: item.code ?? item.Code,
                    description: item.description ?? item.Description,
                    ksefValue: item.ksefValue ?? item.KsefValue
                }));
            },
            recipientRoleOptions() {
                const options = (this.recipientRoles || []).map(item => ({
                    value: item.id ?? item.Id,
                    label: item.label ?? item.Label ?? item.code ?? item.Code ?? "",
                    code: item.code ?? item.Code,
                    description: item.description ?? item.Description
                }));
                return [
                    {
                        value: null,
                        label: this.$t("com.file.client-invoice-data-settings.no-role"),
                        code: null,
                        description: null
                    },
                    ...options
                ];
            },
            buyerGroupCode() {
                return (this.selectedBuyerGroup?.code || "").toUpperCase();
            },
            isRecipientRequired() {
                return this.buyerGroupCode === "JST" || this.buyerGroupCode === "GV";
            },
            isRecipientRoleLocked() {
                return this.isRecipientRequired;
            },
            showRecipientSection() {
                return this.wantsRecipient || this.isRecipientRequired;
            },
            mainRecipientHeaderTitle() {
                const name = (this.model.recipient?.name || "").trim();
                const key = "com.file.client-invoice-data-settings.recipient-main";
                const t = this.$t(key);
                return name ? name : (t !== key ? t : "Odbiorca główny");
            },
            hasError() {
                const buyerErr = this.isRequiredMissing(this.model.buyer.name)
                    || this.isRequiredMissing(this.model.buyer.taxId)
                    || (this.isValidNipDigitsOnly(this.model.buyer.taxId) === false && this.selectedCountry != null && this.selectedCountry.symbol === 'PL' && (this.model.recipientInternalIdentifier == null || this.model.recipientInternalIdentifier == ''))
                    || this.isInvoiceEmailInvalid(this.model.invoiceEmail)
                    || this.isTooLong(this.model.invoiceEmail, this.maxLengths.invoiceEmail)
                    || this.isTooLong(this.model.buyer.name, this.maxLengths.buyerName)
                    || this.isTooLong(this.model.buyer.address, this.maxLengths.buyerAddress)
                    || this.isTooLong(this.model.buyer.postalCode, this.maxLengths.buyerPostalCode)
                    || this.isTooLong(this.model.buyer.city, this.maxLengths.buyerCity)
                    || this.isTooLong(this.model.buyer.postOffice, this.maxLengths.buyerPostOffice)
                    || this.isTooLong(this.model.buyer.taxId, this.maxLengths.buyerTaxId)
                    || this.isTooLong(this.model.buyer.gln, this.maxLengths.buyerGln);
                const recipientErr = this.showRecipientSection && (
                    (this.model.recipient.taxId && this.isValidNipDigitsOnly(this.model.recipient.taxId) === false && this.selectedRecipientCountry != null && this.selectedRecipientCountry.symbol === 'PL')
                    || this.isTooLong(this.model.recipient.name, this.maxLengths.recipientName)
                    || this.isTooLong(this.model.recipient.address, this.maxLengths.recipientAddress)
                    || this.isTooLong(this.model.recipient.postalCode, this.maxLengths.recipientPostalCode)
                    || this.isTooLong(this.model.recipient.city, this.maxLengths.recipientCity)
                    || this.isTooLong(this.model.recipient.postOffice, this.maxLengths.recipientPostOffice)
                    || this.isTooLong(this.model.recipient.taxId, this.maxLengths.recipientTaxId)
                    || this.isTooLong(this.model.recipient.gln, this.maxLengths.recipientGln)
                    || this.isTooLong(this.model.recipientInternalIdentifier, this.maxLengths.recipientInternalIdentifier)
                    || (this.model.recipientInternalIdentifier && !this.isValidRecipientInternalIdentifier(this.model.recipientInternalIdentifier))
                    || (this.isRecipientRequired && this.isRequiredMissing(this.model.recipient.name))
                    || (this.isRecipientRoleLocked && !this.selectedRecipientRole)
                    || ((!!this.model.recipient.taxId || !!this.model.recipientInternalIdentifier) && (!this.selectedRecipientRole || this.selectedRecipientRole.value == null)));
                return buyerErr || recipientErr || this.hasAdditionalRecipientsError;
            },
            hasAdditionalRecipientsError() {
                const max = this.maxLengths;
                return (this.model.additionalRecipiants || []).some((r, idx) => {
                    const role = this.selectedAdditionalRecipientRoles[idx];
                    const hasData = !!(r.taxId || r.recipientInternalIdentifier);
                    const missingRole = hasData && (!role || role.value == null);
                    const nipInvalid = r.taxId && this.selectedAdditionalRecipientCountries[idx]?.symbol === "PL" && this.isValidNipDigitsOnly(r.taxId) === false;
                    const internalIdInvalid = r.recipientInternalIdentifier && !this.isValidRecipientInternalIdentifier(r.recipientInternalIdentifier);
                    const missingName = hasData && this.isRequiredMissing(r.name);
                    const tooLong = this.isTooLong(r.name, max.recipientName) || this.isTooLong(r.taxId, max.recipientTaxId)
                        || this.isTooLong(r.address, max.recipientAddress) || this.isTooLong(r.city, max.recipientCity)
                        || this.isTooLong(r.postalCode, max.recipientPostalCode) || this.isTooLong(r.postOffice, max.recipientPostOffice)
                        || this.isTooLong(r.gln, max.recipientGln) || this.isTooLong(r.recipientInternalIdentifier, max.recipientInternalIdentifier);
                    return missingRole || nipInvalid || internalIdInvalid || missingName || tooLong;
                });
            }
        },
        methods: {
            closeModal() {
                this.$store.commit("setClientInvoiceBuyerModalStatus", false);
            },
            async loadCountries() {
                const countries = this.$store.state.countryStore.countries || [];
                if (countries.length > 0) {
                    return;
                }
                await CountryService.getCountries();
            },
            async loadBuyerGroups() {
                const response = await ClientInvoiceDataService.getBuyerGroups();
                if (response.status !== 200) {
                    throw await Promise.reject(response);
                }
                this.buyerGroups = response.data || [];
            },
            async loadRecipientRoles() {
                const response = await ClientInvoiceDataService.getRecipientRoles();
                if (response.status !== 200) {
                    throw await Promise.reject(response);
                }
                this.recipientRoles = response.data || [];
            },
            async fetchInvoiceData() {
                const response = await ClientInvoiceDataService.getClientInvoiceData();
                if (response.status !== 200) {
                    throw await Promise.reject(response);
                }
                this.model = response.data || createEmptyData();
                if (!Array.isArray(this.model.additionalRecipiants)) {
                    this.model.additionalRecipiants = [];
                }
                this.selectedCountry = this.getSelectedCountry(this.model.buyer?.country?.id);
                this.selectedRecipientCountry = this.getSelectedCountry(this.model.recipient?.country?.id);
                this.selectedBuyerGroup = this.getSelectedBuyerGroup(this.model.buyerGroup?.id);
                this.selectedRecipientRole = this.getSelectedRecipientRole(this.model.recipientRole?.id);
                this.model.invoiceEmail = (this.model.invoiceEmail || "").trim();
                this.wantsRecipient = this.hasRecipientData();
                this.mainRecipientExpanded = true;
                this.selectedAdditionalRecipientCountries = (this.model.additionalRecipiants || []).map(r =>
                    this.getSelectedCountry(r?.country?.id));
                this.selectedAdditionalRecipientRoles = (this.model.additionalRecipiants || []).map(r =>
                    this.getSelectedRecipientRole(r?.recipientRole?.id));
                this.expandedAdditionalRecipients = {};
                this.applyRecipientRoleFromBuyerGroup();
            },
            hasRecipientData() {
                const r = this.model.recipient;
                if (!r) return false;
                return !!(r.name || r.taxId || r.address || r.city || r.postalCode || r.recipientInternalIdentifier ||
                    (this.model.recipientInternalIdentifier || "").trim());
            },
            isAdditionalRecipientFilled(recipient) {
                if (!recipient) return false;
                const hasName = !!(recipient.name || "").trim();
                return hasName;
            },
            toggleAdditionalRecipient(idx) {
                this.expandedAdditionalRecipients[idx] = !this.expandedAdditionalRecipients[idx];
            },
            isAdditionalRecipientExpanded(idx) {
                return this.expandedAdditionalRecipients[idx] !== false;
            },
            getAdditionalRecipientTitle(idx, recipient) {
                const name = (recipient?.name || "").trim();
                const num = idx + 2;
                const key = "com.file.client-invoice-data-settings.recipient-additional";
                try {
                    const t = this.$t(key, { num });
                    return name ? name : (t !== key ? t : `Odbiorca ${num}`);
                } catch {
                    return name ? name : `Odbiorca ${num}`;
                }
            },
            addAdditionalRecipient() {
                const r = createEmptyRecipient();
                this.model.additionalRecipiants.push(r);
                this.selectedAdditionalRecipientCountries.push(this.defaultCountry);
                this.selectedAdditionalRecipientRoles.push(this.recipientRoleOptions.find(o => o.value == null) || this.recipientRoleOptions[0]);
                this.expandedAdditionalRecipients[this.model.additionalRecipiants.length - 1] = true;
            },
            removeAdditionalRecipient(idx) {
                this.model.additionalRecipiants.splice(idx, 1);
                this.selectedAdditionalRecipientCountries.splice(idx, 1);
                this.selectedAdditionalRecipientRoles.splice(idx, 1);
                const newExpanded = {};
                Object.keys(this.expandedAdditionalRecipients).forEach(k => {
                    const ki = parseInt(k, 10);
                    if (ki < idx) newExpanded[ki] = this.expandedAdditionalRecipients[ki];
                    else if (ki > idx) newExpanded[ki - 1] = this.expandedAdditionalRecipients[ki];
                });
                this.expandedAdditionalRecipients = newExpanded;
            },
            getSelectedCountry(countryId) {
                const found = countryId ? this.countriesOptions.find(item => item.value === countryId) : null;
                return found || this.defaultCountry;
            },
            getSelectedBuyerGroup(groupId) {
                if (!groupId) {
                    return null;
                }
                return this.buyerGroupOptions.find(item => item.value === groupId) || null;
            },
            getSelectedRecipientRole(roleId) {
                if (roleId == null || roleId === undefined) {
                    return this.recipientRoleOptions?.find(o => o.value == null) || null;
                }
                return this.recipientRoleOptions.find(item => item.value === roleId) || null;
            },
            applyRecipientRoleFromBuyerGroup() {
                if (!this.isRecipientRoleLocked) {
                    return;
                }

                const roles = this.recipientRoleOptions;
                let match = null;
                if (this.buyerGroupCode === "JST") {
                    match = roles.find(item => (item.code || "").toUpperCase() === "JST")
                        || roles.find(item => (item.label || "").toLowerCase().includes("jst") && (item.label || "").toLowerCase().includes("odbiorca"));
                }
                if (this.buyerGroupCode === "GV") {
                    match = roles.find(item => (item.code || "").toUpperCase() === "GV")
                        || roles.find(item => (item.label || "").toLowerCase().includes("gv") && (item.label || "").toLowerCase().includes("odbiorca"));
                }

                if (match) {
                    this.selectedRecipientRole = match;
                }
            },
            async saveData() {
                if (this.hasError) {
                    return;
                }
                if (!this.userConfirmTaxData) {
                    return;
                }

                try {
                    this.isSaving = true;
                    this.$store.commit("showLoader");
                    const buyerCountry = this.selectedCountry || this.defaultCountry;
                    const recipientCountry = this.selectedRecipientCountry || this.defaultCountry;
                    if (buyerCountry) {
                        this.model.buyer.country = {
                            id: buyerCountry.value,
                            country: buyerCountry.country,
                            symbol: buyerCountry.symbol
                        };
                    }
                    if (recipientCountry) {
                        this.model.recipient.country = {
                            id: recipientCountry.value,
                            country: recipientCountry.country,
                            symbol: recipientCountry.symbol
                        };
                    }
                    if (this.selectedBuyerGroup) {
                        this.model.buyerGroup = {
                            id: this.selectedBuyerGroup.value,
                            code: this.selectedBuyerGroup.code,
                            label: this.selectedBuyerGroup.label,
                            description: this.selectedBuyerGroup.description,
                            ksefValue: this.selectedBuyerGroup.ksefValue
                        };
                    }
                    if (this.selectedRecipientRole && this.selectedRecipientRole.value != null) {
                        this.model.recipientRole = {
                            id: this.selectedRecipientRole.value,
                            code: this.selectedRecipientRole.code,
                            label: this.selectedRecipientRole.label,
                            description: this.selectedRecipientRole.description
                        };
                    } else {
                        this.model.recipientRole = null;
                    }
                    const filledAdditional = (this.model.additionalRecipiants || [])
                        .map((r, idx) => ({ recipient: r, idx }))
                        .filter(({ recipient }) => this.isAdditionalRecipientFilled(recipient))
                        .map(({ recipient, idx }) => {
                            const selCountry = this.selectedAdditionalRecipientCountries[idx] || this.defaultCountry;
                            const selRole = this.selectedAdditionalRecipientRoles[idx];
                            const r = { ...recipient };
                            if (selCountry) {
                                r.country = { id: selCountry.value, country: selCountry.country, symbol: selCountry.symbol };
                            }
                            if (selRole && selRole.value != null) {
                                r.recipientRole = { id: selRole.value, code: selRole.code, label: selRole.label, description: selRole.description };
                            } else {
                                r.recipientRole = null;
                            }
                            return r;
                        });
                    this.model.additionalRecipiants = filledAdditional;
                    this.model.invoiceEmail = (this.model.invoiceEmail || "").trim();
                    if (!this.model || !this.model.id) {
                        await ClientInvoiceDataService.createClientInvoiceData(this.model);
                    } else {
                        await ClientInvoiceDataService.updateClientInvoiceData(this.model.id, this.model);
                    }
                    await UserService.getAccountErrors();
                    this.closeModal();
                }
                catch (e) {
                    console.log(e);
                }
                finally {
                    this.isSaving = false;
                    this.$store.commit("hideLoader");
                }
            },
            async fetchGusData(nip, destination, additionalIdx) {
                try {
                    this.$store.commit("showLoader");
                    const response = await ClientInvoiceDataService.getGusData(nip);
                    if (response.status === 200) {
                        if (destination === 'buyer') {
                            this.model.buyer.address = response.data.address;
                            this.model.buyer.city = response.data.city;
                            this.model.buyer.name = response.data.name;
                            this.model.buyer.postalCode = response.data.postalCode;
                            this.model.buyer.postOffice = response.data.postOffice;
                        } else if (destination === 'additionalRecipient' && typeof additionalIdx === 'number') {
                            const r = this.model.additionalRecipiants[additionalIdx];
                            if (r) {
                                r.address = response.data.address;
                                r.city = response.data.city;
                                r.name = response.data.name;
                                r.postalCode = response.data.postalCode;
                                r.postOffice = response.data.postOffice;
                            }
                        } else {
                            this.model.recipient.address = response.data.address;
                            this.model.recipient.city = response.data.city;
                            this.model.recipient.name = response.data.name;
                            this.model.recipient.postalCode = response.data.postalCode;
                            this.model.recipient.postOffice = response.data.postOffice;
                        }
                    }
                } catch (error) {
                    console.error("Error fetching GUS data:", error);
                } finally {
                    this.$store.commit("hideLoader");
                }
            },
            isRequiredMissing(value) {
                return (value || "").trim().length === 0;
            },
            isTooLong(value, maxLength) {
                return this.getLength(value) > maxLength;
            },
            getLength(value) {
                return (value || "").length;
            },
            isInvoiceEmailInvalid(email) {
                if (email != null && email != '') {
                    return !!email && validateEmail(email);
                }
                else {
                    return true;
                }
            },
            isValidRecipientInternalIdentifier(value) {
                const trimmed = (value || "").trim();
                if (trimmed.length === 0) return true;
                const pattern = /^[1-9]\d{9}-\d{5}$/;
                return pattern.test(trimmed);
            },
            isValidNipDigitsOnly
        }
    }
</script>
<style lang="scss" scoped>
    .client-invoice-modal {
        scroll-behavior: auto !important;

        :deep(*) {
            scroll-behavior: auto !important;
        }
    }

    .client-invoice-data__group-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 8px;
    }

    .recipient-card {
        border: 1px solid #dde0e7;
        border-radius: 8px;
        overflow: hidden;
        background: #fafbfc;

        &__header {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 12px 16px;
            cursor: pointer;
            background: #fff;
            border-bottom: 1px solid #e8ebef;
            user-select: none;

            &:hover {
                background: #f8f9fb;
            }
        }

        &__title {
            font-weight: 600;
            font-size: 14px;
            color: #00082c;
        }

        &__chevron {
            display: inline-block;
            margin-left: 8px;
            font-size: 10px;
            color: #8f95a3;
            transition: transform 0.08s ease-out;

            &--expanded {
                transform: rotate(180deg);
            }
        }

        &__remove {
            background: none;
            border: none;
            color: #8f95a3;
            cursor: pointer;
            padding: 4px 8px;
            font-size: 16px;
            line-height: 1;
            border-radius: 4px;

            &:hover {
                color: #e53935;
                background: rgba(229, 57, 53, 0.08);
            }
        }

        &__body {
            padding: 16px;
            background: #fff;
            transition: none;
        }
    }

    .client-invoice-data__group__button {
        border: 1px solid #bbc2ce;
        background-color: #ffffff;
        color: #00082c;
        border-radius: 4px;
        padding: 6px 12px;
        font-size: 12px;
        cursor: pointer;
        transition: background-color 0.1s ease-out;

        &:hover {
            background-color: #e8ebef;
        }
    }

    .edit-point-form__checkbox-top {
        display: flex;
        align-items: center;
        margin-top: 12px;
    }

    .edit-point-form__checkbox {
        width: 0px;
        height: 0px;
        display: none;

        &:checked ~ .edit-point-form__checkbox-mark {
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }

    .edit-point-form__checkbox-wrapper {
        width: 0px;
        height: 24px;
        position: relative;

        &:before {
            content: "";
            background: #ffffff;
            border: 1px solid #d1d6df;
            box-sizing: border-box;
            box-shadow: 1px 1px 2px rgba(0, 8, 44, 0.06);
            border-radius: 4px;
            width: 24px;
            height: 24px;
            position: relative;
            display: block;
            top: 0px;
            left: 0px;
            opacity: 1;
        }
    }

    .edit-point-form__checkbox-mark {
        background: #00082c;
        border: 1px solid #00082c;
        box-sizing: border-box;
        box-shadow: 1px 1px 2px rgba(0, 8, 44, 0.06);
        border-radius: 4px;
        width: 24px;
        height: 24px;
        position: absolute;
        z-index: 5;
        display: none;
        top: 0px;
        left: 0px;
        opacity: 1;
    }

    .edit-point-form__label {
        font-weight: 600;
        font-size: 14px;
        line-height: 145%;
        color: #00082c;

        &--checkbox {
            padding-left: 32px;
            z-index: 10;
            cursor: pointer;
            font-weight: normal !important;
        }
    }

    .recipient-internal-id-info {
        margin-top: 4px;

        &__text {
            font-size: 12px;
            line-height: 1.4;
            color: #8f95a3;
        }
    }

    .input-has-error {
        border-color: red;
    }

    .esesja-modal__wraper__body__input:disabled {
        background-color: #f2f4f8;
        color: #8f95a3;
        cursor: not-allowed;
    }



    .client-invoice-modal {
        .button-show {
            width: 20%;
            height: 50px;
            background: #ffffff;
            border: 1px solid #d1d6df;
            box-sizing: border-box;
            //box-shadow: 1px 1px 3px rgba(0, 8, 44, 0.06);
            border-radius: 4px;
            border-left: 0px;
            border-top-left-radius: 0px;
            border-bottom-left-radius: 0px;
            //position: relative;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;

            &::after {
                content: "";
                position: absolute;
                left: 0px;
                top: 50%;
                transform: translateY(-50%);
                height: 40px;
                width: 1px;
                background: #e2e5eb;
            }
        }

        .esesja-modal__row {
            margin-bottom: 0px;
        }

        .esesja-modal__wraper__body__input {
            margin-top: 0px;
        }
    }
</style>
